import React from 'react';
import { PhaseFormFieldData } from '@/features/phaseForm/types';
import FileUploadManager, { UploadingFile } from './FileUploadManager';

interface FieldWrapperProps {
  field: PhaseFormFieldData;
  children: React.ReactNode;
  onFileUpload: (fieldId: string, files: string[], uploadingFiles: UploadingFile[]) => void;
  processId: string;
  phaseFormId: string;
  uploadingFiles?: UploadingFile[];
}

export const FieldWrapper: React.FC<FieldWrapperProps> = ({
  field,
  children,
  onFileUpload,
  processId,
  phaseFormId,
  uploadingFiles = []
}) => {
  if (!field.acceptFiles) {
    return <>{children}</>;
  }

  return (
    <div className="w-full space-y-6">
      <div>
        {children}
      </div>
      
      <div className="border-t border-background/20 pt-6">
        <div className="mb-4">
          <h3 className="text-background font-semibold text-sm mb-2">
            📎 Anexar arquivos
          </h3>
          <p className="text-grey-light text-xs">
            Você pode anexar documentos relacionados a este campo (opcional)
          </p>
        </div>
        
        <FileUploadManager 
          onFilesChange={(files, currentUploadingFiles) => onFileUpload(field._id, files, currentUploadingFiles)}
          existingPaths={field.files || []}
          uploadingFiles={uploadingFiles}
          processId={processId}
          phaseFormId={phaseFormId}
        />
      </div>
    </div>
  );
}; 